import React from 'react';
import T from 'prop-types';

export const ProcessingToastContent = ({ name, allowSchedulingProgress }) =>
  allowSchedulingProgress ? (
    <p>Your export{name ? `, ${name},` : ''} has been started. We will notify you when complete.</p>
  ) : (
    <div>
      <h6 className="text-bold mb-xxxs">We’re generating your export</h6>
      <p>We’ll let you know when your export is ready for download.</p>
    </div>
  );

ProcessingToastContent.propTypes = {
  name: T.string,
  allowSchedulingProgress: T.bool,
};

export const QueuedToastContent = ({ name, queuePosition }) => (
  <p>
    Your export{name ? `, ${name},` : ''} is being processed (queue position #{queuePosition}). We
    will notify you when complete.
  </p>
);

QueuedToastContent.propTypes = {
  name: T.string,
  queuePosition: T.number,
};
